'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { fetchReferences } from '@eliadmin/core/src/api/references/references-api';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import type { Reference } from '@eliadmin/core/src/api/references/references-types';

export const ReferencesList = ({
  cardTitle,
  showMore,
}: {
  cardTitle: string;
  showMore: string;
}) => {
  const locale = useLocaleStore((s) => s.currentLocale);
  const referencesQuery = useSuspenseInfiniteQuery({
    queryKey: ['references', locale],
    queryFn: async ({ pageParam = 1 }) => {
      return await fetchReferences({
        locale,
        query: {
          page: pageParam,
          results: 6,
          orderBy: 'year',
          order: 'desc',
        },
      });
    },
    getNextPageParam: (lastPage: any, pages) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page)
        return lastPage?.meta?.current_page + 1;
      return undefined;
    },
    initialPageParam: 1,
  });

  const references = referencesQuery.data?.pages.flatMap((page: any) => page.data) ?? [];

  return (
    <>
      {references?.map((reference) => {
        {
          /** ${urlMap[locale] || urlMap['sk']} */
        }
        const referenceUrl = `/referencie/${reference?.slug}`;
        return (
          <div key={reference?.slug} className={cn('', 'ea-references-page__reference-card')}>
            <div
              className={cn('group transition', 'ea-references-page__reference-image-container')}
            >
              <div className={cn('', 'ea-custom-gallery__slide-overlay transition')} />
              <Image
                src={reference?.image?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(reference?.image, reference?.name, reference?.name ?? '')}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
              />
              <Button asChild className={cn('transition', 'ea-custom-gallery__hover-button')}>
                <Link href={referenceUrl}>{cardTitle}</Link>
              </Button>
            </div>
            <div className="p-4">
              <p className={cn('decorated-font', 'ea-references-page__reference-name')}>
                {reference?.name}
              </p>
            </div>
          </div>
        );
      })}
      <div
        className={cn('', 'ea-references-page__show-more-div', {
          hidden: !referencesQuery.hasNextPage,
        })}
      >
        <Button
          onClick={() => referencesQuery.fetchNextPage()}
          isLoading={referencesQuery.isFetchingNextPage}
          variant={'outline'}
          className="text-white"
        >
          {showMore}
        </Button>
      </div>
    </>
  );
};
